import {HttpClient, transformToDataSource, transformToHttpFailure} from '@verihubs/pandora';
import {Environment} from '../../../core/environment';
import {GetIncidentHistoryDTO, SystemEntity, SubscribeEmailNotificationDTO} from '../Entity';
import {RemoteRepository} from './Repository';

export class RemoteRepositoryImpl extends HttpClient implements RemoteRepository {
  constructor() {
    super(`${Environment.baseUrl}/v1/status`);
  }

  public GetIncidentHistory(payload: GetIncidentHistoryDTO): Promise<SystemEntity[]> {
    return this.request('GET', `/history/${payload.service}`, {
      start: payload.fromDate,
      end: payload.toDate,
    })
      .then(result => transformToDataSource(result))
      .then(result => {
        return (result.data as []).map(val => SystemEntity.fromJSON(val));
      })
      .catch(ex => {
        throw transformToHttpFailure(ex);
      });
  }

  public GetStatus(): Promise<SystemEntity[]> {
    return this.request('GET', '/all')
      .then(result => transformToDataSource(result))
      .then(result => {
        return (result.data as []).map(val => SystemEntity.fromJSON(val));
      })
      .catch(ex => {
        throw transformToHttpFailure(ex);
      });
  }

  public SubscribeEmailNotificationCallback(
    payload: SubscribeEmailNotificationDTO
  ): Promise<boolean> {
    return this.request('PUT', '/subscription', {
      email: payload.email,
      service_names: payload.services.filter(el => el),
    })
      .then(() => {
        return Promise.resolve(true);
      })
      .catch(ex => {
        throw transformToHttpFailure(ex);
      });
  }

  public SubscribeEmailNotification(payload: SubscribeEmailNotificationDTO): Promise<boolean> {
    return this.request('POST', '/subscription/send', {
      email: payload.email,
      service_names: payload.services.filter(el => el),
    })
      .then(result => {
        return result.data.is_sent === true;
      })
      .catch(ex => {
        throw transformToHttpFailure(ex);
      });
  }

  public UnsubscribeEmailNotificationCallback(payload: string): Promise<boolean> {
    return this.request('DELETE', `/subscription/unsubscribe/${payload}`)
      .then(result => {
        return result.data.unsubscribed === true;
      })
      .catch(ex => {
        throw transformToHttpFailure(ex);
      });
  }
}
